
//#region
import { useState, useEffect, useMemo } from 'react';
// material
import { Container, Stack, Typography, Select, MenuItem, FormControl, FormControlLabel, Switch, Grid, InputLabel, Modal, Box, Fade, Accordion, AccordionSummary, AccordionDetails, Button } from "@mui/material";
import ReactSelect from 'react-select';
import toast from 'react-hot-toast';
// components
import Page from "../components/Page";
import Loader from "./Loader";
import _, { set } from 'lodash';
import Controls from '../components/controls/Controls';
import { getConfig, updateConfig } from '../config/services/config';
import getDataFromCube from '../utils/getCubeData';
import { reportExport, reportImport, getReportsList } from '../config/services/reports';
import { ReactComponent as DropDownIcon } from "../assets/icons/icon-angle-down.svg"
import b64ToBlob from "b64-to-blob";
import fileSaver from "file-saver";
import { makeStyles } from "@mui/styles";
import { ListItemText, Checkbox, Paper, IconButton, InputAdornment, TextField } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { ReactComponent as InputSearchIcon } from "../assets/icons/icon-feather-search.svg"
import DatePicker from "react-datepicker";
import { ReactComponent as CalendarIcon } from "../assets/icons/icon_calender.svg";
import moment from 'moment'
import { getAllMeasuresList, getMeasuresList } from '../config/services/measures';
import { getDatasets } from '../config/services/datasets';
import { getPreAggList, deletePreAgg } from '../config/services/preAggregation'
import settings from "../config/settings";

const useStyles = makeStyles({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    marginTop: '-8px',
  },
  search: {
    marginBottom: "1px",
  },
  card: {
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    display: 'flex',
    backgroundColor: "#fff4f0",
  },
  menuDropdownItem: {
    fontSize: '14px',
    color: '#202124',
    '&:hover': {
      backgroundColor: '#f6f6f6'
    }
  }
});


function Settings() {
  const measureSearchData = [];
  const classes = useStyles();
  const { env } = settings
  const [preAgg, setPreAgg] = useState(true)
  const [refreshKey, setRefreshKey] = useState('')
  const [version, setVersion] = useState('')
  const [loading, setLoading] = useState(false)
  const [refreshKeyInterval, setRefreshKeyInterval] = useState('')
  const [profileMapping, setProfileMapping] = useState([{ reportId: '', reportName: '', profileName: [] }])
  const [staticReportsDetails, setStaticReportsDetails] = useState([{ title: '', query: '', profileName: [], showLabel: true, label: '', dataKey: '', dataSetName: '', dataSetId: '' }])
  const [staticDashboardId, setStaticDashboardId] = useState('')
  const [profiles, setProfiles] = useState([])
  const [reportList, setReportList] = useState([])
  const [profileMenuOpen, setProfileMenuOpen] = useState({});
  const [reportMenuOpen, setReportMenuOpen] = useState({});
  const [profileSearchData, setProfilesSearchData] = useState([])
  const [reportSearchData, setReportSearchData] = useState([])
  const [openStaticReportPopup, setOpenStaticReportPopup] = useState(false)
  const [staticProfileMenuOpen, setStaticProfileMenuOpen] = useState({})
  const [staticReportIndex, setStaticReportIndex] = useState(0)

  const [maxStartDate, setMaxStartDate] = useState(Date.now())
  //const [minEndDate, setMinEndDate] = useState(new Date("01/01/2021"))
  const [isSameDayStartTime, setIsSameDayStartTime] = useState(false)
  //const [isSameDayEndTime, setIsSameDayEndTime] = useState(false)
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [measureList, setMeasureList] = useState([])
  const [dimensionList, setDimensionList] = useState([])

  const [measureMenuOpen, setMeasureMenuOpen] = useState({});
  //const [measureSearchData, setMeasureSearchData] = useState([])

  const [dimensionMenuOpen, setDimensionMenuOpen] = useState({});
  const [dimensionSearchData, setDimensionSearchData] = useState([])
  const [searchMeasureInput, setSearchMeasureInput] = useState('')
  const [searchDimensionInput, setSearchDimensionInput] = useState('')
  const [dataSetList, setDatasetList] = useState([])
  const [searchDataSetInput, setSearchDataSetInput] = useState('')
  const [dataSetMenuOpen, setDataSetMenuOpen] = useState({})
  const [profileMappingIndex, setProfileMappingIndex] = useState(null)
  const [categoryReports, setCategoryReports] = useState([])
  const [categoryMenuOpen, setCategoryMenuOpen] = useState(false)
  const [categorySearchData, setCategorySearchData] = useState([])
  const [preAggrList, setPreAggrList] = useState([])
  const [preAggDeleteArr, setPreAggDeleteArr] = useState([])
  const [preAggSearchData, setPreAggSearchData] = useState([])
  const [preAggMenuOpen, setPreAggMenuOpen] = useState(false)
  const [deleteMeasDataSetName, setDeleteMeasDataSetName] = useState('')
  const [deleteMeasDataSetMenuOpen, setDeleteMeasDataSetMenuOpen] = useState(false)
  const [calculatedFields, setCalculatedFields] = useState([])
  const [delMeasArr, setDelMeasArr] = useState([])
  const [delMeasMenuOpen, setDelMeasMenuOpen] = useState(false)
  const [deleteMeasDataSetId, setDeleteMeasDataSetId] = useState('')
  const [delMeasureSearchInput, setDelMeasureSearchInput] = useState('')
  const [exportReportPopup, setExportReportPopup] = useState(false)
  const [uploadFile, setUploadFile] = useState("")
  const [selectedAction, setSelectedAction] = useState("")
  const [exportReportMenuOpen, setExportReportMenuOpen] = useState(false)
  const [exportReports, setExportReports] = useState([])
  const [searchReport, setSearchReport] = useState("")
  const [exportLoader, setExportLoader] = useState(false)
  const [selectedFile, setSelectedFile] = useState('')

  const handlePreaggChange = async (e) => {
    let { checked } = e.target
    setPreAgg(checked)
  }
  const handleVersionUpdate = (e) => {
    const version = new Date().getTime().toString()
    setVersion(version)
    updateConfig({ version: version }).then(res => {
      setLoading(false)
      toast.success(res?.message)
    })
  }
  const handleRefrehKey = (e) => {
    const { value } = e?.target;
    setRefreshKey(value)
  }

  const handleRefreshKeyInterval = (e) => {
    const { value } = e?.target
    setRefreshKeyInterval(value)
  }

  function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    const hDisplay = h > 0 ? h + (h == 1 ? "." : ".0") : "";
    const mDisplay = m > 0 ? m : "";
    var sDisplay = s > 0 ? s + '.s' : "";
    return hDisplay + mDisplay + sDisplay
  }


  const handleSubmit = () => {
    const update = {}
    if (!refreshKey) {
      toast.error('Refresh Key is required')
      return
    }
    if (refreshKey) update.refreshKey = refreshKey
    if (version) update.version = version
    if (preAgg === true) update.preAgg = preAgg
    if (preAgg === false) update.preAgg = preAgg
    if (refreshKeyInterval) {
      if (refreshKeyInterval.split('.')?.length === 2) {
        const refreshKeyIntervalArr = refreshKeyInterval.split('.')
        if (refreshKeyIntervalArr[1] === 's') {
          const sec = refreshKeyIntervalArr[0]
          update.refreshKeyInterval = sec
        }
        else {
          const hr = refreshKeyIntervalArr[0];
          const minute = refreshKeyIntervalArr[1];
          const sec = parseInt(hr) * 60 * 60 + parseInt(minute) * 60
          update.refreshKeyInterval = sec
        }
      }
      else {
        const sec = parseInt(refreshKeyInterval) * 60;
        update.refreshKeyInterval = sec
      }
    }

    if (profileMapping?.length) {
      update.staticProfileMapping = profileMapping
    }
    if (staticReportsDetails?.length) {
      update.staticReports = handleStaticQueryDateFilter(startDate)
    }
    if (staticDashboardId) {
      update.staticDashboardId = staticDashboardId.trim()
    }
    update.staticStartDate = startDate
    if (endDate) {
      update.staticEndDate = endDate
    }

    setLoading(true)
    updateConfig(update).then(res => {
      setLoading(false)
      toast.success(res?.message)
    })
  }

  const handleExportReportOpen = () => {
    setExportReportMenuOpen(true)
  }

  const handleExportReportSearch = (e) => {
    setSearchReport(e.target.value)
  }

  const handleProfileMenuOpen = (index) => {
    setProfilesSearchData([])
    let currState = profileMenuOpen[index]
    setProfileMenuOpen({ ...profileMenuOpen, [index]: !currState })
  }

  const handleReportMenuOpen = (index) => {
    setReportSearchData([])
    let currState = reportMenuOpen[index]
    setReportMenuOpen({ ...reportMenuOpen, [index]: !currState })
  }

  const handleStaticQueryDateFilter = (date) => {
    if (!staticReportsDetails?.length && date) {
      toast.error('Static Report Details is required')
      return
    }

    let filter = {
      operator: 'afterDate',
      values: [date]
    }

    let staticDetails = [...staticReportsDetails]
    for (let report of staticDetails) {
      let reportDetailsQuery = JSON.parse(report?.query)

      let dataSetName = null
      if (reportDetailsQuery.dimensions?.length > 0) {
        dataSetName = reportDetailsQuery.dimensions[0]?.split('.')[0];
      }
      else if (reportDetailsQuery.measures?.length > 0) {
        dataSetName = reportDetailsQuery.measures[0]?.split('.')[0];
      }
      else if (reportDetailsQuery.timeDimensions?.length > 0 && reportDetailsQuery.timeDimensions[0].dimension) {
        dataSetName = reportDetailsQuery.timeDimensions[0].dimension?.split('.')[0]
      }

      if (dataSetName === settings.PROGRESS_REPORT_DATASET || dataSetName === settings.ATTENDANCE_DATASET) {
        filter.member = dataSetName + '.' + 'createDate'
      }
      else if (dataSetName !== settings.PROGRESS_REPORT_DATASET || dataSetName !== settings.ATTENDANCE_DATASET) { filter.member = dataSetName + '.' + 'dateTime' }

      if (reportDetailsQuery.filters.length) {
        const exist = reportDetailsQuery?.filters.find(filter => filter?.operator === 'afterDate')
        if (exist) {
          exist.values = [date]
        }
        else {
          reportDetailsQuery.filters.push(filter)
        }
      }
      else {
        reportDetailsQuery.filters = []
        reportDetailsQuery.filters.push(filter)
      }
      report.query = JSON.stringify(reportDetailsQuery)
    }
    setStaticReportsDetails(staticReportsDetails)
    return staticReportsDetails
  }

  const handleStaticProfileMenu = (index) => {
    let currState = staticProfileMenuOpen[index]
    setReportSearchData([])
    setStaticProfileMenuOpen({ ...staticProfileMenuOpen, [index]: !currState })
  }

  const handleDimensionMenuOpen = (index) => {
    setSearchDimensionInput('')
    let currState = dimensionMenuOpen[index]
    setDimensionMenuOpen({ ...dimensionMenuOpen, [index]: !currState })
  }

  const handleMeasureMenuOpen = (index) => {
    setSearchMeasureInput('')
    let currState = measureMenuOpen[index]
    setMeasureMenuOpen({ ...measureMenuOpen, [index]: !currState })
  }

  const handleOnCloseExportPopup = () => {
    setExportReports([])
    setUploadFile("")
    setSelectedAction("")
    setExportReportPopup(false)
  }

  const handledataSetMenuOpen = (index) => {
    setSearchDataSetInput('')
    let currState = dataSetMenuOpen[index]
    setDataSetMenuOpen({ ...dataSetMenuOpen, [index]: !currState })
  }

  const handleProfileMultiSelect = (e) => {
    if (profileMapping[profileMappingIndex]?.profileName?.length) {
      !profileMapping[profileMappingIndex]?.profileName?.some(ele => ele === e?.target?.value[0]) ? e.target.value = [...e.target.value, ...profileMapping[profileMappingIndex]?.profileName] : e.target.value = profileMapping[profileMappingIndex]?.profileName?.filter(ele => ele !== e.target.value[0])
      let mapping = _.cloneDeep(profileMapping)
      mapping[profileMappingIndex].profileName = e.target.value
      setProfileMapping(mapping)
    }
    else {
      let mapping = _.cloneDeep(profileMapping)
      mapping[profileMappingIndex].profileName = e.target.value
      setProfileMapping(mapping)
    }
  }


  const handleReportSelect = (e, id) => {
    const reportName = e?.target?.value;
    let mapping = _.cloneDeep(profileMapping)

    mapping[profileMappingIndex].reportName = reportName
    mapping[profileMappingIndex].reportId = id
    setProfileMapping(mapping)
  }

  const handleStaticProfileMultiSelect = (e) => {
    if (staticReportsDetails[staticReportIndex]?.profileName?.length) {
      !staticReportsDetails[staticReportIndex]?.profileName?.some(ele => ele === e?.target?.value[0]) ? e.target.value = [...e.target.value, ...staticReportsDetails[staticReportIndex]?.profileName] : e.target.value = staticReportsDetails[staticReportIndex]?.profileName?.filter(ele => ele !== e.target.value[0])
      let staticDetails = [...staticReportsDetails]
      staticDetails[staticReportIndex].profileName = e.target.value
      setStaticReportsDetails(staticDetails)

    }
    else {
      let staticDetails = [...staticReportsDetails]
      staticDetails[staticReportIndex].profileName = e.target.value
      setStaticReportsDetails(staticDetails)
    }
  }




  const handleCategoryMultiSelect = (e, id) => {
    //   if(categoryReports?.length) {
    //           !categoryReports?.some(ele => ele?.reportId === id) ? e.target.value = [{reportName: e.target.value, reportId: id}, ... categoryReports : e.target.value = categoryReports?.filter(ele => ele?.reportId !== id) 
    //           let categoryDetails = _.cloneDeep(categoryReports)
    //           staticDetails[staticReportIndex].profileName = e.target.value
    //            setStaticReportsDetails(staticDetails)

    //       }
    //       else {
    //          let staticDetails = [...staticReportsDetails]
    //          staticDetails[staticReportIndex].profileName = e.target.value
    //          setStaticReportsDetails(staticDetails)
    //       }

  }


  const getProfileName = async () => {
    const members = [`${settings.STUDENT_PROFILE_DATASET}.profileName`]
    const data = await getDataFromCube(undefined, undefined, undefined, "static_dashboard", members);
    if (data?.length && Object.keys(data[0]).length) {
      const profileData = data.map(ele => (ele[`${settings.STUDENT_PROFILE_DATASET}.profileName`]))
      setProfiles(profileData)
    }
  }

  const getReportList = async () => {
    let params = { search: searchReport, type: 'superadmin' }
    const response = await getReportsList(params)
    if (response && response?.result?.length) {
      setReportList(response?.result)
    }
  }

  useEffect(async () => {
    const response = await getConfig();
    if (response?.result) {
      const { preAggEnabled, version, refreshKey, refreshKeyInterval, staticProfileMapping, staticReports, staticDashboardId, staticStartDate, staticEndDate } = response?.result
      setPreAgg(preAggEnabled)
      setVersion(version)
      setRefreshKey(refreshKey)
      setRefreshKeyInterval(secondsToHms(refreshKeyInterval))
      if (staticReports) setStaticReportsDetails(staticReports)
      if (staticProfileMapping && staticProfileMapping?.length) {
        setProfileMapping(staticProfileMapping)
      }
      if (staticDashboardId) setStaticDashboardId(staticDashboardId)
      if (staticStartDate) setStartDate(staticStartDate)
      if (staticEndDate) setEndDate(staticEndDate)
    }
  }, [])


  const handleStaticReportDimensionSelect = (e, id) => {
    const name = e?.target?.value;
    let staticReport = _.cloneDeep(staticReportsDetails)

    if (!staticReport[staticReportIndex]?.dataSetId) {
      toast.error('Dataset should be selected first')
      return
    }
    else {
      staticReport[staticReportIndex].label = `${staticReport[staticReportIndex]?.dataSetName}.${name}`
      setStaticReportsDetails(staticReport)
    }
  }

  const handleStaticReportMeasureSelect = (e, id) => {
    const name = e?.target?.value;
    let staticReport = [...staticReportsDetails]

    if (!staticReport[staticReportIndex]?.dataSetId) {
      toast.error('Dataset should be selected first')
      return
    }
    else {
      staticReport[staticReportIndex].dataKey = `${staticReport[staticReportIndex]?.dataSetName}.${name}`
      setStaticReportsDetails(staticReport)
    }
  }

  const fetchAllDatasetsList = () => {
    let params = { search: searchDataSetInput, sortKey: 'displayName', sortOrder: '1' }
    getDatasets(params).then((res) => {
      if (res?.result?.length) {
        setDatasetList(res?.result);
      }
    });
  }

  const handleDatasetSelect = (e, id) => {
    const { value } = e.target;
    let staticReport = _.cloneDeep(staticReportsDetails)
    staticReport[staticReportIndex].dataSetName = value;
    staticReport[staticReportIndex].dataSetId = id;
    setStaticReportsDetails(staticReport)
  }

  const handleDatasetMeasSelect = (e, id) => {
    const { value } = e.target;
    setDeleteMeasDataSetName(value)
    setDeleteMeasDataSetId(id)
    fetchAllMeasureList(id)
  }

  const MultiSelectRow = ({ index, style, data }) => {
    let label = data[index]?.trim();
    let value = data[index]?.trim();
    return <div style={style} key={value}>
      <MenuItem title={label} onClick={(e) => handleProfileMultiSelect({ target: { value: [label] } })} className={classes.menuDropdownItem + " menu-item flex"} value={value}>
        <Checkbox className="form_checkbox" checked={profileMapping[profileMappingIndex]?.profileName?.indexOf(label) > -1} />
        &#8288;<ListItemText primary={label} />
      </MenuItem>
    </div>
  }


  const MultiExportSelectRow = ({ index, style, data }) => {
    let label = data[index]?.reportName?.trim();
    let id = data[index]?._id;
    return <div style={style} key={id}>
      <MenuItem className={classes.menuDropdownItem + " menu-item flex"} value={label}>
        <Checkbox className="form_checkbox" checked={exportReports?.indexOf(label) > -1} />
        &#8288;<ListItemText primary={label} />
      </MenuItem>
    </div>
  }

  const MultiSelectStaticProfileRow = ({ index, style, data }) => {
    let label = data[index]?.trim();
    let value = data[index]?.trim();

    return <div style={style} key={value}>
      <MenuItem onClick={(e) => handleStaticProfileMultiSelect({ target: { value: [value] } })} className={classes.menuDropdownItem + " menu-item flex"} value={value}>
        <Checkbox className="form_checkbox" checked={staticReportsDetails[staticReportIndex]?.profileName?.indexOf(value) > -1} />
        &#8288;<ListItemText primary={label} />
      </MenuItem>
    </div>
  }
  const SelectReportRow = ({ index, style, data }) => {
    let label = data[index]?.reportName
    let value = data[index]?.reportName
    let reportId = data[index]?._id
    let isFolder = data[index]?.isFolder

    if (!isFolder && value) {

      return <div style={style} key={value}>
        <MenuItem onClick={e => handleReportSelect({ target: { value: value } }, reportId)} className="menu-item flex" value={value}>
          &#8288;<ListItemText className="text-plain" primary={label} />
        </MenuItem>
      </div>
    }
    else {
      return null
    }
  }

  const DimensionSelectRow = ({ index, style, data }) => {

    let label = data[index]?.displayName || data[index]?.name
    let value = data[index]?.name
    let dataSetId = data[index]?.dataSetId

    return <div style={style} key={value}>
      <MenuItem onClick={e => handleStaticReportDimensionSelect({ target: { value: value } }, dataSetId)} className="menu-item flex" value={value}>
        &#8288;<ListItemText className="text-plain" primary={label} />
      </MenuItem>
    </div>
  }

  const SelectMeasureRow = ({ index, style, data }) => {
    let label = data[index]?.displayName || data[index]?.name
    let value = data[index]?.name
    let dataSetId = data[index]?.dataSetId

    return <div style={style} key={value}>
      <MenuItem onClick={e => handleStaticReportMeasureSelect({ target: { value: value } }, dataSetId)} className="menu-item flex" value={value}>
        &#8288;<ListItemText className="text-plain" primary={label} />
      </MenuItem>
    </div>
  }

  const dataSetListSelectRow = ({ index, style, data }) => {
    let label = data[index]?.dataSetName
    let value = data[index]?.dataSetName
    let dataSetId = data[index]?._id

    return <div style={style} key={value}>
      <MenuItem onClick={e => handleDatasetSelect({ target: { value: value } }, dataSetId)} className="menu-item flex" value={value}>
        &#8288;<ListItemText className="text-plain" primary={label} />
      </MenuItem>
    </div>
  }


  const handleProfileSearchInput = (e) => {
    e.stopPropagation();
    const value = e?.target?.value
    if (profiles?.length) {
      const filtered = profiles.filter(ele => {
        if (value === "") {
          return profiles
        }
        else if (ele && ele.toLowerCase().trim().includes(value.toLowerCase().trim())) {
          return ele;
        }
      })
      setProfilesSearchData(filtered)
    }
  }

  const handleReportSearchInput = (e) => {
    e.stopPropagation();
    const value = e?.target?.value
    if (reportList?.length) {
      const filtered = reportList.filter(ele => {
        if (value === "") {
          return reportList
        }
        else if (ele && ele?.reportName && ele?.reportName.toLowerCase().trim().includes(value.toLowerCase().trim())) {
          return ele;
        }
      })
      setReportSearchData(filtered)
    }
  }

  const handleCancelStaticReport = () => {
    setOpenStaticReportPopup(false)
  }

  const isJson = (str) => {
    try {
      JSON.parse(str);
    }
    catch (e) {
      return false;
    }
    return true;
  }

  const addMoreStaticReport = (e, index) => {
    const obj = { title: '', query: '', profileName: [], showLabel: true, label: '', dataKey: '' }

    const report = staticReportsDetails[index];
    const { title, query, profileName } = report;
    if (!title) {
      toast.error('Report Title is required')
      return
    }
    else if (!query) {
      toast.error('Report Query is required')
      return
    }
    else {
      let staticReport = [...staticReportsDetails]
      staticReport.push(obj)
      setStaticReportsDetails(staticReport)
    }
  }

  const removeStaticReport = (e, index) => {
    let staticReport = [...staticReportsDetails]
    staticReport.splice(index, 1)
    setStaticReportsDetails(staticReport)
  }

  const handlerReportTitleChange = (e, index) => {
    const value = e?.target?.value;
    let staticReport = [...staticReportsDetails]
    staticReport[index].title = value;
    setStaticReportsDetails(staticReport)

  }

  const handlerReportLabelChange = (e, index) => {
    const value = e?.target?.value;
    let staticReport = [...staticReportsDetails]
    staticReport[index].label = value;
    setStaticReportsDetails(staticReport)

  }

  const handlerReportQueryChange = (e, index) => {
    const value = e?.target?.value;
    let staticReport = [...staticReportsDetails]
    staticReport[index].query = value.trim().toString()
    setStaticReportsDetails(staticReport)
  }

  const handleShowLabel = (e, index) => {
    const { checked } = e?.target
    let staticReport = [...staticReportsDetails]
    staticReport[index].showLabel = checked
    setStaticReportsDetails(staticReport)
  }

  const handleStartDateReportFilter = async (date) => {
    if (moment(date).isValid()) {
      let edMonth, edDay, edYear, stMonth, stDay, stYear
      let minEdDate = date;
      //setMinEndDate(minEdDate);
      //setIsSameDayEndTime(true)
      if (endDate) {
        edMonth = new Date(endDate).getMonth()
        edDay = new Date(endDate).getDay()
        edYear = new Date(endDate).getFullYear()
        stMonth = new Date(minEdDate).getMonth()
        stDay = new Date(minEdDate).getDay()
        stYear = new Date(minEdDate).getFullYear()


        if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
          setIsSameDayStartTime(false)
        }
        else {
          setIsSameDayStartTime(true)
        }
      }
      else {
        //setIsSameDayEndTime(true)
      }
      date = moment(date).format("YYYY/MM/DD HH:mm:ss")
    }
    else {
      //setIsSameDayEndTime(false)
      //setMinEndDate(new Date("01/01/2021"))
      date = ''
    }
    setStartDate(date);
    handleStaticQueryDateFilter(date)
  }

  const handleEndDateReportFilter = async (date) => {
    if (moment(date).isValid()) {
      let edMonth, edDay, edYear, stMonth, stDay, stYear;
      let maxStDate = date
      setMaxStartDate(maxStDate)
      setIsSameDayStartTime(true)

      if (startDate) {
        edMonth = new Date(startDate).getMonth()
        edDay = new Date(startDate).getDay()
        edYear = new Date(startDate).getFullYear()
        stMonth = new Date(maxStDate).getMonth()
        stDay = new Date(maxStDate).getDay()
        stYear = new Date(maxStDate).getFullYear()


        /* if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
          setIsSameDayEndTime(false)
        }
        else {
          setIsSameDayEndTime(true)
        } */
      } else {
        setIsSameDayStartTime(true)
      }

      date = moment(date).format("YYYY-MM-DD HH:mm:ss")
    }
    else {
      setIsSameDayStartTime(false)
      setMaxStartDate(Date.now())
      date = ''
    }
    setEndDate(date);
  }


  const removeProfileMapping = (e, index) => {
    let mapping = _.cloneDeep(profileMapping)
    if (profileMapping?.length === 1) {
      mapping[index].reportId = ''
      mapping[index].reportName = ''
      mapping[index].profileName = []
    }
    else {
      mapping.splice(index, 1)
    }
    setProfileMapping(mapping)
  }

  const addMoreProfileMapping = (e, index) => {
    const obj = { reportName: '', reportId: '', profileName: [] }
    const mapping = profileMapping[index];
    const { reportId, reportName, profileName } = mapping;
    if (!reportName) {
      toast.error('Report should be selected')
      return
    }
    else if (!profileName) {
      toast.error('Profile should be selected')
      return
    }
    else {
      let reportMapping = _.cloneDeep(profileMapping)
      reportMapping.push(obj)
      setProfileMapping(reportMapping)
    }
  }

  const handleStaticReportSubmit = () => {
    let reportDetails = []
    if (staticReportsDetails.length) {
      for (let report of staticReportsDetails) {
        let { title, query, profileName, showLabel, dataKey, label, dataSetName, dataSetId } = report;
        if (!title) {
          toast.error('Report Title is required')
          return
        }
        else if (!query) {
          toast.error('Report Query is required')
          return
        }
        else if (query && !isJson(query)) {
          toast.error('Invaid Report Query')
          return;
        }
        else {
          // query = JSON.stringify(query)
          reportDetails.push({ title, query, profileName, showLabel, dataKey, label, dataSetName, dataSetId })
        }
      }

      setStaticReportsDetails(reportDetails)
      setOpenStaticReportPopup(false)
    }
  }

  const handleAccordianChange = (expanded, index) => {
    setStaticReportIndex(index)
    if (staticReportsDetails[index]?.dataSetId) {
      fetchMeasureList(staticReportsDetails[index]?.dataSetId)
    }
  }

  const handleProfileMapAccordianChange = (expanded, index) => {
    setProfileMappingIndex(index)
  }

  const fetchMeasureList = async (dataSetId) => {
    if (staticReportIndex) {
      if (staticReportsDetails[staticReportIndex]?.dataSetId) {
        dataSetId = staticReportsDetails[staticReportIndex]?.dataSetId
      }
    }
    const response = await getMeasuresList({ search: searchMeasureInput || searchDimensionInput, sortKey: 'displayName', sortOrder: 1, dataSetId: dataSetId ? dataSetId : staticReportsDetails[staticReportIndex]?.dataSetId ? staticReportsDetails[staticReportIndex]?.dataSetId : '' })
    if (response?.result?.length) {
      const calcFields = response?.result.filter(calc => calc?.calculatedField)
      const measures = response?.result.filter(meas => meas?.dataSetType === 'MEASURE')
      const dimensions = response?.result.filter(meas => meas?.dataSetType === 'DIMENSION')
      setMeasureList(measures)
      setDimensionList(dimensions)
      setCalculatedFields(calcFields)
    }
  }

  const fetchAllMeasureList = async (id) => {

    if (id || deleteMeasDataSetId || delMeasureSearchInput) {
      const response = await getAllMeasuresList({ search: delMeasureSearchInput, sortKey: 'displayName', sortOrder: 1, dataSetId: id || deleteMeasDataSetId, getAll: true })
      if (response?.result?.length) {
        const calcFields = response?.result.filter(calc => calc?.calculatedField)
        setCalculatedFields(calcFields)
      }
    }
  }

  const fetchPreAggList = async () => {
    const response = await getPreAggList();
    if (response.result?.length) {
      setPreAggrList(response.result)
    }
  }
  const handleExportReport = () => {
    setExportLoader(true)
    reportExport({ reportIds: exportReports })
      .then((response) => {
        return response
      })
      .then((zipAsBase64) => {
        const blob = b64ToBlob(zipAsBase64, "application/zip");
        fileSaver.saveAs(blob, `${env}_reports`);
        setExportReports([])
        setExportReportPopup(false)
        setExportLoader(false)
      })
      .catch(err => {
        console.log("Export Error::", err)
        toast.error('Something went wrong')
      })
  }

  const handleFileReader = (event) => {
    let reader = new FileReader();
    setSelectedFile(event.target.files[0])
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e) => {
      setUploadFile({ data: reader.result.split(',').pop(), fileName: event.target.files[0].name })
    };
  }

  const uploadHandler = () => {
    setExportLoader(true)
    let formData = new FormData();
    formData.append('data', uploadFile?.data)
    formData.append('fileName', uploadFile?.fileName)
    formData.append('file', selectedFile)
    reportImport(formData)
      .then(res => {
        if (res) {
          setExportLoader(false)
          toast.success(res?.message)
          setUploadFile("")
          setExportReportPopup(false)
        }
      })
  }

  const handleExportImportAction = (e) => {
    const { value } = e?.target;
    setSelectedAction(value);
  }

  const removePreAgg = async () => {
    if (preAggDeleteArr?.length) {
      let delCount = 0
      for (let agg of preAggDeleteArr) {
        delCount++;
        await deletePreAgg({ name: agg })
      }
      if (delCount === preAggDeleteArr.length) {
        toast.success('Pre-Aggregation deleted successfully!')
        fetchPreAggList()
      }
    }
  }

  useEffect(() => getProfileName(), [])
  useEffect(() => getReportList(), [searchReport])
  useEffect(() => fetchMeasureList(), [searchMeasureInput, searchDimensionInput, staticReportsDetails[staticReportIndex]?.dataSetId])
  useEffect(() => fetchAllMeasureList(), [delMeasureSearchInput])
  useEffect(() => fetchAllDatasetsList(), [searchDataSetInput])
  useEffect(() => fetchPreAggList(), [])



  const handleDomainReports = () => {

  }


  return (
    <>
      <Page title="Extramarks | Settings ">
        <Container className='table_max_width'>
          {loading && <Loader />}

          <Stack direction="row" justifyContent="space-between">
            <Typography variant="h4">Settings</Typography>
            <div>
              <Controls.Button
                text="Update Version"
                variant="contained"
                style={{ width: '200px', margin: '10px' }}
                onClick={handleVersionUpdate}
              />
              <Controls.Button
                text="Export/Import"
                variant="contained"
                style={{ width: '200px', margin: '10px' }}
                onClick={e => setExportReportPopup(true)}
              />
              <GCPSettings />
            </div>

          </Stack>
          <Stack direction="column" alignContent="center" justifyContent="space-between" mt={5} >

            <FormControl style={{ margin: '10px' }}>
              <InputLabel htmlFor="refresh_key">Refresh Key</InputLabel>
              <Select value={refreshKey} onChange={handleRefrehKey} style={{ width: '70%' }}>
                <MenuItem value="dynamic">Dynamic</MenuItem>
                <MenuItem value="every">Every</MenuItem>
              </Select>
            </FormControl>

            <FormControl style={{ margin: '10px' }}>
              <InputLabel htmlFor="refresh_key_timer">Refresh Key Interval </InputLabel>
              <Select value={refreshKeyInterval} onChange={handleRefreshKeyInterval} style={{ width: '70%' }}>

                <MenuItem value="10.s">10 Seconds</MenuItem>
                <MenuItem value="30.s">30 Seconds</MenuItem>
                <MenuItem value="1">1 Minute</MenuItem>
                <MenuItem value="2">2 Minute</MenuItem>
                <MenuItem value="5">5 Minute</MenuItem>
                <MenuItem value="10">10 Minutes</MenuItem>
                <MenuItem value="20">20 Minutes</MenuItem>
                <MenuItem value="40">40 Minutes</MenuItem>
                <MenuItem value="1.0">1 hour</MenuItem>
                <MenuItem value="1.20">1 hour 20 Minutes </MenuItem>
                <MenuItem value="1.40">1 hour 40 Minutes</MenuItem>
                <MenuItem value="2.0">2 hour</MenuItem>
              </Select>
            </FormControl>

            <FormControl style={{ margin: '10px' }}>
              <FormControlLabel
                className="text-plain"
                control={<Switch
                  onChange={handlePreaggChange} checked={preAgg} />}
                label="Pre Aggregation" />
            </FormControl>
            <hr className="configLineBreak" />
            {/* //Static Dashboard Configuration Starts// */}

            <FormControl style={{ margin: '10px' }}>

              <Grid mb={2} mt={2}>
                <Typography htmlFor="">Dashboard ID</Typography>
                <TextField style={{ width: '50%' }} value={staticDashboardId} onChange={e => setStaticDashboardId(e.target.value)} type="text" ></TextField>
              </Grid>
              <Stack direction="row" alignItems="center">


                <Accordion
                  style={{ width: '70%' }}
                  className="filter_accordian" >
                  <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                    <Typography variant='h6' className="font-weight-500 form_input_label">Profile Mapping</Typography>
                  </AccordionSummary>
                  <AccordionDetails className="filter_accordian_details" >

                    {profileMapping.map((mapping, index) => (
                      <Accordion
                        style={{ width: '100%' }}
                        onChange={(e, expanded) => handleProfileMapAccordianChange(expanded, index)}
                        key={index}
                        className="filter_accordian" >
                        <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                          <Typography variant='h6' className="font-weight-500 form_input_label">Select Profile Mapping</Typography>
                        </AccordionSummary>
                        <AccordionDetails className="filter_accordian_details" >

                          <div style={{ marginBottom: '14px', display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: '10px', width: '40%' }}>
                              <Typography htmlFor="">Report List</Typography>
                              <Select
                                style={{ width: '100%' }}
                                value={mapping?.reportName}
                                renderValue={selected => selected}
                                open={reportMenuOpen[index]}
                                onClose={e => handleReportMenuOpen(index)}
                                onOpen={e => handleReportMenuOpen(index)}
                                MenuProps={{
                                  classes: {
                                    root: `form-select-menu`
                                  }
                                }}
                              >
                                <div className={classes.header}>
                                  <Paper className={classes.card} elevation={3}>
                                    <IconButton className="form-icon-btn" onClick={e => handleReportMenuOpen(index)} color="primary"> <CancelIcon /></IconButton>
                                  </Paper>
                                </div>
                                <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search field"
                                  onChange={handleReportSearchInput}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="start">
                                        <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                                      </InputAdornment>
                                    ),
                                  }} />

                                <div className={`virtual-filter-div ` + ((reportSearchData.length || reportList.length) ? 'filter-data-exists' : ``)}>
                                  <AutoSizer>
                                    {({ height, width }) => (
                                      <FixedSizeList
                                        className="List"
                                        height={(reportSearchData.length ? reportSearchData : reportList).length ? height : 20}
                                        itemCount={(reportSearchData.length ? reportSearchData : reportList).length}
                                        width={width - 6}
                                        itemData={(reportSearchData.length ? reportSearchData : reportList)}
                                        itemSize={60}
                                      >
                                        {SelectReportRow}
                                      </FixedSizeList>
                                    )}
                                  </AutoSizer>
                                </div>

                              </Select>
                            </div>

                            <div style={{ width: '40%' }}>
                              <Typography htmlFor="">Profile List</Typography>
                              <Select
                                fullWidth
                                multiple
                                style={{ width: '100%' }}
                                value={mapping?.profileName}
                                renderValue={(selected) => selected.join(", ")}
                                open={profileMenuOpen[index]}
                                onClose={e => handleProfileMenuOpen(index)}
                                onOpen={e => handleProfileMenuOpen(index)}
                                MenuProps={{
                                  classes: {
                                    root: `form-select-menu`
                                  }
                                }}
                              >
                                <div className={classes.header}>
                                  <Paper className={classes.card} elevation={3}>
                                    <IconButton className="form-icon-btn" onClick={e => handleProfileMenuOpen(index)} color="primary"> <CancelIcon /></IconButton>
                                  </Paper>
                                </div>
                                <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search field"
                                  onChange={handleProfileSearchInput}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="start">
                                        <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                                      </InputAdornment>
                                    ),
                                  }} />

                                <div className={`virtual-filter-div ` + ((profileSearchData.length || profiles.length) ? 'filter-data-exists' : ``)}>
                                  <AutoSizer>
                                    {({ height, width }) => (
                                      <FixedSizeList
                                        className="List"
                                        height={(profileSearchData.length ? profileSearchData : profiles).length ? height : 20}
                                        itemCount={(profileSearchData.length ? profileSearchData : profiles).length}
                                        width={width - 6}
                                        itemData={(profileSearchData.length ? profileSearchData : profiles)}
                                        itemSize={60}
                                      >
                                        {MultiSelectRow}
                                      </FixedSizeList>
                                    )}
                                  </AutoSizer>
                                </div>

                              </Select>
                            </div>

                          </div>

                          <div>
                            <Controls.Button
                              className="report_form_ui_btn cancel mr-2"
                              color="secondary"
                              text="Remove"
                              onClick={e => removeProfileMapping(e, index)}
                            />

                            {
                              index === profileMapping.length - 1 &&
                              <Controls.Button
                                className="report_form_ui_btn submit"
                                type="submit"
                                text="Add More"
                                onClick={e => addMoreProfileMapping(e, index)}
                              />
                            }
                          </div>

                        </AccordionDetails>
                      </Accordion>
                    ))
                    }
                  </AccordionDetails>
                </Accordion>

                <Grid mt={3} ml={5}>
                  <Controls.Button
                    onClick={e => setOpenStaticReportPopup(true)}
                    type="submit"
                    text="Static Reports"
                  />
                </Grid>
              </Stack>
              {/* <Grid mb={2} width="70%">
               <Typography htmlFor="">Select Category Reports</Typography>
               <Select 
                            fullWidth
                              multiple
                              style={{width:'100%'}}
                              value={categoryReports} 
                              renderValue={(selected) => selected?.reportName?.join(", ")}
                              open={categoryMenuOpen}
                              onClose={handleCategoryMenuOpen}
                              onOpen={handleCategoryMenuOpen}
                              MenuProps={{
                                  classes:{
                                      root: `form-select-menu`
                                  }
                              }}
                          >
                              <div className={classes.header}>
                                  <Paper className={classes.card} elevation={3}>
                                      <IconButton className="form-icon-btn" onClick={handleCategoryMenuOpen} color="primary"> <CancelIcon /></IconButton>
                                  </Paper>
                              </div>
                              <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search field"
                              onChange={handleCategorySearchInput}
                              InputProps={{
                              endAdornment: (
                                  <InputAdornment position="start">
                                      <InputSearchIcon className="input_search_icon" sx={{mr: '8px'}} />
                                  </InputAdornment>
                                  ),
                              }} />

                            <div className={`virtual-filter-div ` + ((reportSearchData.length || reportList.length) ? 'filter-data-exists' : ``)}>
                              <AutoSizer>
                                  {({ height, width }) => ( 
                                  <FixedSizeList
                                      className="List"
                                      height={(categorySearchData.length ? categorySearchData : reportList ).length?height:20}
                                      itemCount={(categorySearchData.length ? categorySearchData : reportList ).length}
                                      width={width - 6}
                                      itemData={(categorySearchData.length ? categorySearchData : reportList )}
                                      itemSize={60}
                                  >
                                      {MultiCategorySelectRow}
                                  </FixedSizeList>
                                  )}
                              </AutoSizer>
                              </div>

                          </Select>
            </Grid> */}

              <Grid container item alignItems="start" justifyContent="flex-start" spacing={2} sm={12} md={12} lg={12} my={2} >
                <Grid item xs={6} md={4} lg={4}>
                  <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss" placeholderText={"Start Date"} className="report_form_ui_input_date er-input-filter"
                    minDate={new Date("01-01-2021 00:00:00")}
                    maxDate={maxStartDate}
                    minTime={new Date("2021-01-01 00:00:00")}
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                    onChangeRaw={(e) => e.preventDefault()}
                    maxTime={!isSameDayStartTime ? moment.utc().endOf('day') : maxStartDate}
                    selected={startDate ? new Date(startDate) : null} onChange={(date) => handleStartDateReportFilter(date)}
                    isClearable
                    customInput={
                      <TextField className="report_form_ui_input_date er-input-filter"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="start">
                              <CalendarIcon />
                            </InputAdornment>
                          ),
                        }} />
                    }
                  />
                </Grid>


                {/* <Grid item xs={6} md={4} lg={4}>
              <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss" showTimeSelect
                minDate={minEndDate}
                maxDate={new Date()} placeholderText={"End Date"} className="report_form_ui_input_date er-input-filter"
                selected={endDate ? new Date(endDate) : null} onChange={(date) => handleEndDateReportFilter(date)}
                minTime={!isSameDayEndTime ? moment.utc().endOf('day') : setHours(setMinutes(new Date(), new Date(minEndDate).getMinutes()), new Date(minEndDate).getHours())}
                maxTime={new Date().setHours(23, 59, 59, 999)}
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                onChangeRaw={(e) => e.preventDefault()}
                isClearable
                customInput={
                  <TextField className="report_form_ui_input_date er-input-filter"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <CalendarIcon />
                        </InputAdornment>
                      ),
                    }} />
                }
              />
              </Grid> */}
              </Grid>
            </FormControl>

            {/* //Static Dashboard Configuration Ends// */}


          </Stack>

          <Grid item xs={8}>
            <div>
              <Controls.Button
                onClick={handleSubmit}
                type="submit"
                text="submit"
              />
            </div>
          </Grid>

        </Container>


        {/* /*** Static Reports Modal Starts */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className="modal-root"
          open={openStaticReportPopup}
          onClose={() => setOpenStaticReportPopup(false)}
          closeAfterTransition
        >
          <Fade in={openStaticReportPopup}>
            <Box style={{ maxHeight: '80vh', overflow: 'auto' }} className="modal-paper modal-box modal-lg" id="transition-modal-title">
              <Box className="modal-header" >
                <Typography variant="subtitle1" className="modal-header-title" >Add Static Reports</Typography>
              </Box>
              <Box className="modal-content">

                <Stack direction="column" width="100%">

                  {

                    staticReportsDetails && staticReportsDetails.map((report, index) => (
                      <Accordion
                        onChange={(e, expanded) => handleAccordianChange(expanded, index)}
                        key={index}
                        className="filter_accordian" >
                        <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                          <Typography variant='h6' className="font-weight-500 form_input_label">{report?.title || 'Add Report'}</Typography>
                        </AccordionSummary>
                        <AccordionDetails className="filter_accordian_details">

                          <Grid mb={2} width="100%">
                            <InputLabel>Report Title</InputLabel>
                            <TextField fullWidth type="text" onChange={e => handlerReportTitleChange(e, index)} value={report?.title}></TextField>
                          </Grid>

                          <Grid mb={2} width="100%">
                            <InputLabel>Report Label</InputLabel>
                            <TextField fullWidth type="text" onChange={e => handlerReportLabelChange(e, index)} value={report?.label}></TextField>
                          </Grid>

                          <Grid mb={2} width="100%">
                            <InputLabel>Report Query</InputLabel>
                            <TextField fullWidth
                              multiline
                              value={isJson(report?.query) ? (report?.query).replaceAll('\\', '').replace(/['"]+/g, '') : report?.query}
                              onChange={e => handlerReportQueryChange(e, index)}
                              rows={4}
                              variant="outlined"
                            />
                          </Grid>

                          <Grid mb={2}>
                            <InputLabel>Add Profile</InputLabel>
                            <Select

                              fullWidth
                              value={staticReportsDetails[index]?.profileName}
                              renderValue={(selected) => selected.join(", ")}
                              open={staticProfileMenuOpen[index]}
                              onClose={e => handleStaticProfileMenu(index)}
                              onOpen={e => handleStaticProfileMenu(index)}
                              MenuProps={{
                                classes: {
                                  root: `form-select-menu`
                                }
                              }}
                            >
                              <div className={classes.header}>
                                <Paper className={classes.card} elevation={3}>
                                  <IconButton className="form-icon-btn" onClick={e => handleProfileMenuOpen(index)} color="primary"> <CancelIcon /></IconButton>
                                </Paper>
                              </div>
                              <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search field"
                                onChange={handleProfileSearchInput}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                                    </InputAdornment>
                                  ),
                                }} />

                              <div className={`virtual-filter-div ` + ((profileSearchData.length || profiles.length) ? 'filter-data-exists' : ``)}>
                                <AutoSizer>
                                  {({ height, width }) => (
                                    <FixedSizeList
                                      className="List"
                                      height={(profileSearchData.length ? profileSearchData : profiles).length ? height : 20}
                                      itemCount={(profileSearchData.length ? profileSearchData : profiles).length}
                                      width={width - 6}
                                      itemData={(profileSearchData.length ? profileSearchData : profiles)}
                                      itemSize={60}
                                    >
                                      {MultiSelectStaticProfileRow}
                                    </FixedSizeList>
                                  )}
                                </AutoSizer>
                              </div>

                            </Select>
                          </Grid>

                          <Grid mb={2} display="flex">

                            <div style={{ marginRight: '10px', width: '30%' }}>
                              <Typography htmlFor="">Select DataSet</Typography>
                              <Select
                                style={{ width: '100%' }}
                                value={staticReportsDetails[index]?.dataSetName}
                                renderValue={(selected) => selected}
                                open={dataSetMenuOpen[index]}
                                onClose={e => handledataSetMenuOpen(index)}
                                onOpen={e => handledataSetMenuOpen(index)}
                                MenuProps={{
                                  classes: {
                                    root: `form-select-menu`
                                  }
                                }}
                              >
                                <div className={classes.header}>
                                  <Paper className={classes.card} elevation={3}>
                                    <IconButton className="form-icon-btn" onClick={e => handledataSetMenuOpen(index)} color="primary"> <CancelIcon /></IconButton>
                                  </Paper>
                                </div>
                                <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search field"
                                  onChange={e => setSearchDataSetInput(e.target.value)}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="start">
                                        <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                                      </InputAdornment>
                                    ),
                                  }} />

                                <div className={`virtual-filter-div ` + ((dimensionSearchData.length || dataSetList.length) ? 'filter-data-exists' : ``)}>
                                  <AutoSizer>
                                    {({ height, width }) => (
                                      <FixedSizeList
                                        className="List"
                                        height={(dimensionSearchData.length ? dimensionSearchData : dataSetList).length ? height : 20}
                                        itemCount={(dimensionSearchData.length ? dimensionSearchData : dataSetList).length}
                                        width={width - 6}
                                        itemData={(dimensionSearchData.length ? dimensionSearchData : dataSetList)}
                                        itemSize={60}
                                      >
                                        {dataSetListSelectRow}
                                      </FixedSizeList>
                                    )}
                                  </AutoSizer>
                                </div>

                              </Select>
                            </div>

                            <div style={{ marginRight: '10px', width: '30%' }}>
                              <Typography htmlFor="">Select Label</Typography>
                              <Select
                                style={{ width: '100%' }}
                                value={report?.label}
                                renderValue={(selected) => selected?.split('.')[1] || selected}
                                open={dimensionMenuOpen[index]}
                                onClose={e => handleDimensionMenuOpen(index)}
                                onOpen={e => handleDimensionMenuOpen(index)}
                                MenuProps={{
                                  classes: {
                                    root: `form-select-menu`
                                  }
                                }}
                              >
                                <div className={classes.header}>
                                  <Paper className={classes.card} elevation={3}>
                                    <IconButton className="form-icon-btn" onClick={e => handleDimensionMenuOpen(index)} color="primary"> <CancelIcon /></IconButton>
                                  </Paper>
                                </div>
                                <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search field"
                                  onChange={e => setSearchDimensionInput(e.target.value)}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="start">
                                        <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                                      </InputAdornment>
                                    ),
                                  }} />

                                <div className={`virtual-filter-div ` + ((dimensionSearchData.length || dimensionList.length) ? 'filter-data-exists' : ``)}>
                                  <AutoSizer>
                                    {({ height, width }) => (
                                      <FixedSizeList
                                        className="List"
                                        height={(dimensionSearchData.length ? dimensionSearchData : dimensionList).length ? height : 20}
                                        itemCount={(dimensionSearchData.length ? dimensionSearchData : dimensionList).length}
                                        width={width - 6}
                                        itemData={(dimensionSearchData.length ? dimensionSearchData : dimensionList)}
                                        itemSize={60}
                                      >
                                        {DimensionSelectRow}
                                      </FixedSizeList>
                                    )}
                                  </AutoSizer>
                                </div>

                              </Select>
                            </div>

                            <div style={{ width: '30%' }}>
                              <Typography htmlFor="">Select Data Key</Typography>
                              <Select
                                style={{ width: '100%' }}
                                value={report?.dataKey}
                                renderValue={(selected) => selected?.split('.')[1] || selected}
                                open={measureMenuOpen[index]}
                                onClose={e => handleMeasureMenuOpen(index)}
                                onOpen={e => handleMeasureMenuOpen(index)}
                                MenuProps={{
                                  classes: {
                                    root: `form-select-menu`
                                  }
                                }}
                              >
                                <div className={classes.header}>
                                  <Paper className={classes.card} elevation={3}>
                                    <IconButton className="form-icon-btn" onClick={e => handleMeasureMenuOpen(index)} color="primary"> <CancelIcon /></IconButton>
                                  </Paper>
                                </div>
                                <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search field"
                                  onChange={e => setSearchMeasureInput(e.target.value)}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="start">
                                        <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                                      </InputAdornment>
                                    ),
                                  }} />

                                <div className={`virtual-filter-div ` + ((measureSearchData.length || measureList.length) ? 'filter-data-exists' : ``)}>
                                  <AutoSizer>
                                    {({ height, width }) => (
                                      <FixedSizeList
                                        className="List"
                                        height={(measureSearchData.length ? measureSearchData : measureList).length ? height : 20}
                                        itemCount={(measureSearchData.length ? measureSearchData : measureList).length}
                                        width={width - 6}
                                        itemData={(measureSearchData.length ? measureSearchData : measureList)}
                                        itemSize={60}
                                      >
                                        {SelectMeasureRow}
                                      </FixedSizeList>
                                    )}
                                  </AutoSizer>
                                </div>

                              </Select>
                            </div>
                          </Grid>


                          <Grid mb={2} display="flex" alignItems="center">
                            <InputLabel>Show Label</InputLabel>
                            <Checkbox
                              onChange={e => handleShowLabel(e, index)}
                              value={report?.showLabel}
                              checked={report?.showLabel}
                              color="primary"
                              inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                          </Grid>
                          <div>
                            <Controls.Button
                              className="report_form_ui_btn cancel mr-2"
                              color="secondary"
                              text="Remove"
                              disabled={staticReportsDetails?.length === 1}
                              onClick={e => removeStaticReport(e, index)}
                            />

                            {index === staticReportsDetails?.length - 1 &&
                              <Controls.Button
                                className="report_form_ui_btn submit"
                                type="submit"
                                text="Add More"
                                onClick={e => addMoreStaticReport(e, index)}
                                disabled={(!staticReportsDetails[index]?.title || !staticReportsDetails[index]?.query)}
                              />
                            }
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    ))

                  }

                  <Grid mt={5}>
                    <Controls.Button
                      className="report_form_ui_btn cancel mr-2"
                      color="secondary"
                      text="Cancel"
                      onClick={handleCancelStaticReport}
                    />
                    <Controls.Button
                      className="report_form_ui_btn submit"
                      type="submit"
                      text="submit"
                      onClick={handleStaticReportSubmit}
                    // disabled={syncingDataSets}
                    />
                  </Grid>


                </Stack>
              </Box>

            </Box>
          </Fade>
        </Modal>
        {/*** Static Reports Modal Ends */}

        {/*** Export Report Popup Start */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className="modal-root"
          open={exportReportPopup}
          closeAfterTransition
        >
          <Fade in={exportReportPopup}>
            <Box style={{ maxHeight: '80vh' }} className="modal-paper modal-box modal-lg" id="transition-modal-title">
              {exportLoader && <Loader />}
              <Box className="modal-header" >
                <Typography variant="subtitle1" className="modal-header-title" >Export/Import Reports</Typography>
              </Box>
              <Box className="modal-content">
                <Stack direction="column" width="100%">
                  <FormControl>
                    <InputLabel htmlFor="Action">Action</InputLabel>
                    <Select value={selectedAction} onChange={handleExportImportAction}>
                      <MenuItem value="export">Export Report</MenuItem>
                      <MenuItem value="import">Import Report</MenuItem>
                    </Select>
                  </FormControl>
                  {

                    selectedAction === "export" ?
                      <div style={{ marginTop: '10px' }}>
                        <ReactSelect
                          classNamePrefix="select"
                          isMulti
                          options={reportList}
                          menuPlacement='auto'
                          getOptionLabel={(option) => option.reportName}
                          getOptionValue={(option) => option._id}
                          value={exportReports}
                          onChange={e => setExportReports(e)}
                        />

                      </div>
                      : selectedAction === "import" ?

                        <div style={{ marginTop: '10px' }}>
                          <FormControl>
                            <Button
                              variant="contained"
                              component="label"
                              className="report_form_ui_btn cancel mr-2 mt-2"
                            >
                              Select File
                              <input
                                type="file"
                                accept=".zip,.rar,.7zip"
                                hidden
                                onChange={handleFileReader}
                              />
                            </Button>
                          </FormControl>
                          <InputLabel style={{ fontSize: '12px', marginTop: '10px' }}>{uploadFile?.fileName}</InputLabel>

                        </div>

                        : null
                  }
                </Stack>
                <Grid mt={5}>
                  <Controls.Button
                    className="report_form_ui_btn cancel mr-2"
                    color="secondary"
                    text="Cancel"
                    onClick={handleOnCloseExportPopup}
                  />
                  <Controls.Button
                    className="report_form_ui_btn submit"
                    type="submit"
                    text={selectedAction === "export" ? 'Export' : selectedAction === "import" ? 'Import' : 'Submit'}
                    onClick={selectedAction === "export" ? handleExportReport : uploadHandler}
                    disabled={!exportReports?.length && !uploadFile}
                  />
                </Grid>

              </Box>
            </Box>
          </Fade>
        </Modal>
        {/*** Export Report Popup Start ***/}
      </Page>
    </>
  )
}

export default Settings

function GCPSettings() {
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [jsonFile, setJsonFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileSelect = (e) => {
    if(e.target.files[0]){
      const fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0]);
      fileReader.onload = () => {
        setJsonFile({fileName: e.target.files[0].name, Data: fileReader.result.split(',').pop()})
      }
      fileReader.onerror = (error) => {
        console.log('file read error', error);
      }
    }
  }

  const handleCancel = () => {
    setIsModelOpen(false);
    setJsonFile(null);
  }

  const handleUpload = async () => {
    setIsUploading(true);
    updateConfig({ gcpKeyFileInfo: {
      ...jsonFile
    } }).then(res => {
      setIsUploading(false)
      toast.success(res?.message);
      setIsModelOpen(false);
    }).catch(err => {
      setIsUploading(false)
      toast.error(err?.message)
    });
  }

  return (
    <>
      <Controls.Button
        text="Add GCP Settings"
        variant="contained"
        style={{ width: '200px', margin: '10px' }}
        onClick={() => setIsModelOpen(true)}
      />

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={isModelOpen}
        closeAfterTransition
      >
        <Fade in={isModelOpen}>
          <Box style={{ maxHeight: '80vh' }} className="modal-paper modal-box modal-lg" id="transition-modal-title">
            {isUploading && <Loader />}
            <Box className="modal-header" >
              <Typography variant="subtitle1" className="modal-header-title">GCP config</Typography>
            </Box>
            <Box className="modal-content">
              <Stack direction="column" width="100%">
                <FormControl>
                  <Button
                    variant="contained"
                    component="label"
                    className="report_form_ui_btn cancel mr-2 mt-2"
                  >
                    {jsonFile ? 'Change File' : 'Select File'}
                    <input
                      type="file"
                      accept=".json"
                      hidden
                      onChange={handleFileSelect}
                    />
                  </Button>
                </FormControl>
                <InputLabel style={{ fontSize: '12px', marginTop: '10px' }}>{jsonFile?.fileName}</InputLabel>
              </Stack>
              <Grid mt={5}>
                <Controls.Button
                  className="report_form_ui_btn cancel mr-2"
                  color="secondary"
                  text="Cancel"
                  onClick={handleCancel}
                />
                <Controls.Button
                  className="report_form_ui_btn submit"
                  type="submit"
                  text="upload"
                  onClick={handleUpload}
                  disabled={!jsonFile}
                />
              </Grid>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  )
}